import { useTranslate } from 'react-polyglot';

import { QrIcon } from '@genially/icons';

import { useHostClientContext } from '../../../../../HostClientProvider/hooks/useHostClientContext';
import { useHostGameContext } from '../../../../HostGame.context';
import { useOpenQrCodeModal } from '../../../../hooks/useOpenQrCodeModal';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const ShowQrCodeSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar } = useHostGameContext();
  const { client } = useHostClientContext();
  const { openQrCodeModal } = useOpenQrCodeModal();

  const handleClick = () => {
    settingsSidebar.close();
    openQrCodeModal();
  };

  return (
    <SidebarLink
      Icon={QrIcon}
      text={t('__new.play.shared.showQrCode')}
      onClick={handleClick}
      disabled={client.game.isSessionBlocked}
    ></SidebarLink>
  );
};
